import { put, call, takeLatest, all, select } from "redux-saga/effects";
import {
    search, getPatientPhoto, getRoomStatuses, getConsumerJWT, getTwilioConsumerJWT,
    getEpicFluRecords, getCompleteFluStatus, getPeopleSoftFluStatus, copyFluStatusToPS, getVideoVisitTermsAndConditionsForShareLink, getVideoVisitTCStatusForShareLink, acceptVideoVisitShareLinkTC, deleteConsent
} from "../api/portalApi";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";

export default function* profileToolsSaga() {
    yield takeLatest(types.SITE_SEARCH_START, handleSiteSearch);
    yield takeLatest(types.PATIENT_PHOTO_START, handlePatientPhoto);
    yield takeLatest(types.GET_CONSUMER_JWT, handleGetConsumerJWT);
    yield takeLatest(types.GET_PROVIDER_JWT, handleGetProviderJWT);
    yield takeLatest(types.REVOKE_HP_FHIR_GRANT, handleRevokeHPFHIRGrant);

    if (window.serverData.data.enableFluVaccine) {
        yield takeLatest(types.GET_COMPLETE_FLU_STATUS, handleCompleteFluStatus);
       // yield takeLatest(types.USER_AUTHENTICATE_SUCCESS, handleGetRoomStatuses);
    }
    else {
        yield put({ type: types.DISABLE_FLU });
    }

    yield takeLatest([types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK], getTermsForVideoVisitShareLink);

    yield takeLatest([types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK], getStatusOfTermsForVideoVisitShareLink);

    yield takeLatest([types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK], acceptTermsForVideoVisitShareLink);

}

export function* handleSiteSearch(payload) {
    const start = new Date();

    try {
        //debugger;
        const resultsObject = yield call(search, payload.searchPhrase, payload.token);
        if (resultsObject.fetchSuccessful) {
            yield put({ type: types.SITE_SEARCH_SUCCESS, searchResults: resultsObject.results });
            logAPI("MBHWeb.Saga.Portal.SiteSearch", start, null);
        }
        else {
            yield put({ type: types.SITE_SEARCH_FAILURE, searchError: resultsObject.actualError || resultsObject.displayError });
            logAPI("MBHWeb.Saga.Portal.SiteSearch.Failure", start, null);

        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.SiteSearch.Failure", start, null);
        yield all([
            put({ type: types.SITE_SEARCH_SUCCESS, searchError: error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }

}

export function* handlePatientPhoto() {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);

        if (!domainData || !domainData.t) {
            yield put({ type: types.PATIENT_PHOTO_FAILURE, error: 'Sorry, it appears your not logged in.' });
            logAPI("MBHWeb.Saga.Portal.PatientPhoto.Failure", start, null);
            return;
        }

        if (!domainData.cu || !domainData.cu.ei) {
            yield put({ type: types.PATIENT_PHOTO_FAILURE, error: 'Sorry, it appears the patient has no external id.' });
            logAPI("MBHWeb.Saga.Portal.PatientPhoto.Failure", start, null);
            return;
        }

        const response = yield call(getPatientPhoto, domainData.t, domainData.cu.ei, 'External');
        if (response.isPhotoPresent) {
            yield put({ type: types.PATIENT_PHOTO_SUCCESS, response: response.photo });
            logAPI("MBHWeb.Saga.Portal.PatientPhoto", start, null);
        }
        else {
            yield put({ type: types.PATIENT_PHOTO_FAILURE, error: 'No photo found.' });
            logAPI("MBHWeb.Saga.Portal.PatientPhoto.Failure", start, null);
        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.PatientPhoto.Failure", start, null);
        yield all([
            put({ type: types.PATIENT_PHOTO_FAILURE, error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}

/*export function* handleEpicFluRecord() {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        const primaryUser = domain.pu ? domain.pu.mi.toLowerCase() : "";
        const currentUser = domain.cu ? domain.cu.mi.toLowerCase() : "";
        const isPrimary = (primaryUser !== "" && currentUser === "") || primaryUser === currentUser;

        if (isPrimary) {
            yield put({ type: types.GET_EPIC_FLU_RECORD_PENDING });

            const response = yield call(getEpicFluRecords, domain.t);
            if (response.fetchSuccessful) {
                yield put({ type: types.GET_EPIC_FLU_RECORD_SUCCESS, results: response.results });
                logAPI("MBHWeb.Saga.Portal.EpicFlu", start, null);
            }
            else {
                yield put({ type: types.GET_EPIC_FLU_RECORD_FAILURE, searchError: error });
                logAPI("MBHWeb.Saga.Portal.EpicFlu.Failure", start, null);
            }
        }
        else {
            console.log("can't get flu status for non-primary user");
        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.EpicFlu.Failure", start, null);
        yield all([
            put({ type: types.GET_EPIC_FLU_RECORD_FAILURE, searchError: error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}

export function* handlePeopleSoftFluRecord() {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        const primaryUser = domain.pu ? domain.pu.mi.toLowerCase() : "";
        const currentUser = domain.cu ? domain.cu.mi.toLowerCase() : "";
        const isPrimary = (primaryUser !== "" && currentUser === "") || primaryUser === currentUser;

        if (isPrimary) {
            yield put({ type: types.GET_PEOPLESOFT_FLU_RECORD_PENDING });

            const response = yield call(getPeoplePlaceFluRecords, domain.t);
            if (response.fetchSuccessful) {
                yield put({ type: types.GET_PEOPLESOFT_FLU_RECORD_SUCCESS, results: response.results });
                logAPI("MBHWeb.Saga.Portal.PeopleSoftFlu", start, null);
            }
            else {
                yield put({ type: types.GET_PEOPLESOFT_FLU_RECORD_FAILURE });
                logAPI("MBHWeb.Saga.Portal.PeopleSoftFlu.Failure", start, null);
            }
        }
        else {
            console.log("Can't get flu status for non-primary user.");
        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.PeopleSoftFlu.Failure", start, null);
        yield all([
            put({ type: types.GET_PEOPLESOFT_FLU_RECORD_FAILURE, searchError: error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}
*/
export function* handleCompleteFluStatus() {
    const start = new Date();

    try {
        yield put({ type: types.GET_COMPLETE_FLU_STATUS_PENDING });
        const domain = yield select((state) => state.domain);
        const isPrimary = !domain.ip
        const hasEmployee = domain && domain.ie ? true : false;
        if (isPrimary && hasEmployee) {
            let response = null;
            response = yield call(getCompleteFluStatus, domain.t);

            if (response.fetchSuccessful) {
                yield put({ type: types.GET_COMPLETE_FLU_STATUS_SUCCESS, results: response });
                logAPI("MBHWeb.Saga.Portal.CompleteFluStatus", start, null);
            }
            else {
                yield put({ type: types.GET_COMPLETE_FLU_STATUS_FAILURE });
                logAPI("MBHWeb.Saga.Portal.CompleteFluStatus.Failure", start, null);
            }
        }
        else {
            yield put({ type: types.GET_COMPLETE_FLU_STATUS_FAILURE });
            console.log("Can't get flu status for non-primary user.");
        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.CompleteFluStatus.Failure", start, null);
        yield all([
            put({ type: types.GET_COMPLETE_FLU_STATUS_FAILURE, searchError: error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}

export function* handleGetRoomStatuses() {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        const statuses = yield call(getRoomStatuses, domain.t);
        yield put({ type: types.GET_ROOM_STATUSES_SUCCESS, statuses });
        logAPI("MBHWeb.Saga.Portal.GetRoomStatuses", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.GetRoomStatuses.Failure", start, null);
        yield put({ type: types.GET_ROOM_STATUSES_FAILURE });
    }
}

export function* handleGetConsumerJWT(payload) {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_CONSUMER_JWT_PENDING });
        const consumerToken = yield call(getTwilioConsumerJWT, domain.t, payload.participantExternalId, payload.participantName, payload.csnId, payload.epicExternalProviderId);
        yield put({ type: types.GET_CONSUMER_JWT_SUCCESS, consumerToken });
        logAPI("MBHWeb.Saga.Portal.GetConsumerJWT", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.GetConsumerJWT.Failure", start, null);
    }
}

export function* handleGetProviderJWT(payload) {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_CONSUMER_JWT_PENDING });
        const providerToken = yield call(getConsumerJWT, domain.t, payload.participantExternalId, payload.participantName, payload.roomId);
        yield put({ type: types.GET_CONSUMER_JWT_SUCCESS, providerToken });
        logAPI("MBHWeb.Saga.Portal.GetConsumerJWT", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Portal.GetConsumerJWT.Failure", start, null);
    }
}

export function* getTermsForVideoVisitShareLink(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING });
        const response = yield call(getVideoVisitTermsAndConditionsForShareLink, domain.t, payload.featureId);
        if (response && response.isSuccessful) {
            logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.GetTerms.Success", start, null, { shareLinkCode: payload.shareLinkCode, response });
            yield put({ type: types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS, terms: response });
        } else {
            logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.GetTerms.Failure", start, null, { shareLinkCode: payload.shareLinkCode, response });
            yield put({ type: types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE });
        }
    }
    catch (err) {
        yield put({ type: types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE });
        console.error(err);
        logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.GetTerms.Failure", start, null, { shareLinkCode: payload.shareLinkCode, err });
    }
}

export function* getStatusOfTermsForVideoVisitShareLink(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_PENDING });
        const response = yield call(getVideoVisitTCStatusForShareLink, domain.t, payload.shareLinkCode);
        logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.GetTermsStatus.Success", start, null, { shareLinkCode: payload.shareLinkCode, response });
        yield put({ type: types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS, response: response });
        if (payload.callback) {
            payload.callback(response);
        }
    }
    catch (err) {
        yield put({ type: types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_FAILURE });
        if (payload.callback) {
            payload.callback(null);
        }
        console.error(err);
        logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.GetTermsStatus.Failure", start, null, { shareLinkCode: payload.shareLinkCode, err });
    }
}

export function* acceptTermsForVideoVisitShareLink(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING });
        const response = yield call(acceptVideoVisitShareLinkTC, domain.t, payload.termsAndConditions, payload.shareLinkCode);
        if (response && response.httpResponse && response.httpResponse.isSuccessStatusCode) {
            yield put({ type: types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS, response: response });
            logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.AcceptTerms.Success", start, null, { shareLinkCode: payload.shareLinkCode, response });
        } else {
            throw response;
        }
        if (payload.callback) {
            payload.callback(response);
        }
    }
    catch (err) {
        yield put({ type: types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE });
        if (payload.callback) {
            payload.callback(null);
        }
        logAPI("MBHWeb.Saga.Portal.VideoVisitShareLink.AcceptTerms.Failure", start, null, { shareLinkCode: payload.shareLinkCode, err });
    }
}

export function* handleRevokeHPFHIRGrant(payload) {
    const start = new Date();
    yield put({ type: types.REVOKE_HP_FHIR_GRANT_PENDING });
    try {
        const domain = yield select((state) => state.domain);
        const consentBody = {
            ClientName: payload.data.consent.clientName || '',
            ClientDesc: payload.data.consent.clientDesc || '',
            ClientId: payload.data.consent.clientId || '',
            Data: payload.data.consent.data || '',
            Description: payload.data.consent.description || '',
            Key: payload.data.consent.key || '',
            SessionId: payload.data.consent.sessionId || '',
            SubjectId: payload.data.consent.subjectId || '',
            Type: payload.data.consent.type || ''
        }

        const response = yield call(deleteConsent, domain.t, consentBody);
        if (response && response.isSuccessful) {
            logAPI("MBHWeb.Saga.Portal.RevokeConsent.Success", start, null, { consentKey: payload.data.consent.key, response });
            yield put({ type: types.REVOKE_HP_FHIR_GRANT_SUCCESS, consent: payload.data.consent });
            if (payload.callback) {
                payload.callback(response);
            }
        } else {
            yield put({ type: types.REVOKE_HP_FHIR_GRANT_FAILURE });
            if (payload.callback) {
                payload.callback(null);
            }
            console.error(err);
            logAPI("MBHWeb.Saga.Portal.RevokeConsent.Failure", start, null, { consentKey: payload.consent, err: response.Error });
        }
    }
    catch (err) {
        yield put({ type: types.REVOKE_HP_FHIR_GRANT_FAILURE });
        if (payload.callback) {
            payload.callback(null);
        }
        console.error(err);
        logAPI("MBHWeb.Saga.Portal.RevokeConsent.Failure", start, null, { consentKey: payload.consent, err });
    }
}